import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationInitNewCavernsMapArgs,
  InitNewCavernsMapResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation InitNewCavernsMap($playerId: String!, $startingLevel: Int!, $gameSubmode: String!) {
  initNewCavernsMap(playerId: $playerId, startingLevel: $startingLevel, gameSubmode: $gameSubmode) {
    currency2
    game_submode
    startingRoom
    startingLevel
    spawned_mobs
    white_units
  }
}
`;

export default async function mutationInitNewCavernsMap(args: MutationInitNewCavernsMapArgs) {
  return await graphqlClient.request<InitNewCavernsMapResult>('initNewCavernsMap', mutation, args);
}
